import "core-js/modules/esnext.global-this.js";
// packages/react/use-layout-effect/src/use-layout-effect.tsx
import * as React from "react";
var useLayoutEffect2 = globalThis !== null && globalThis !== void 0 && globalThis.document ? React.useLayoutEffect : function () {};
export { useLayoutEffect2 as useLayoutEffect };